import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ValueField } from 'src/app/settings/model/value-field';

@Component({
  selector: 'app-label-fields-selector-dialog',
  templateUrl: './label-fields-selector-dialog.component.html',
  styleUrls: ['./label-fields-selector-dialog.component.scss']
})
export class LabelFieldsSelectorDialogComponent {

  form: FormGroup;

  constructor(public dialogRef: MatDialogRef<LabelFieldsSelectorDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: FieldsData,
    private formBuilder: FormBuilder, private translate: TranslateService) {
    const defaultValues = data.defaultValues;
    this.form = this.formBuilder.group({
      fields: new FormControl(defaultValues, [Validators.required, requiredAnyField(data.requireAny)])
    });
  }

  get fieldsControl(): AbstractControl {
    return this.form.get('fields');
  }

  get requiredFieldsNames(): string {
    return this.data.requireAny.map(field => this.translate.instant(field.name)).join(', ');
  }
}

export function requiredAnyField(required: ValueField[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const selected: ValueField[] = control.value;
    const requiredIndex = selected.findIndex(field => required.some(requiredField => requiredField.name == field.name));
    if (requiredIndex < 0)
      return { noRequiredField: true };
    return null;
  };
}

export interface FieldsData {
  fields: ValueField[];
  requireAny: ValueField[];
  defaultValues: ValueField[];
}
